import { useTranslator } from '@/hooks/useTranslator'
import { classes } from '@lc/libreact'
import { Button } from './Button'
import styles from './ButtonCloseModalPopup.scss'

type ButtonCloseModalPopupProps = {
	onClose: () => void
	closePicto?: string
	ariaLabel?: string
	isModal?: boolean
}

export function ButtonCloseModalPopup({
	onClose,
	closePicto,
	ariaLabel,
	isModal = false,
}: ButtonCloseModalPopupProps) {
	const translator = useTranslator()

	return (
		<Button
			className={classes(styles.closeButton, [
				styles.closeModal,
				isModal,
			])}
			onClick={onClose}
			level="close"
			iconUrl={closePicto ?? 'assets/Cross.svg'}
			iconClassName={styles.picto}
			aria-label={translator.translate(
				ariaLabel ?? 'modal:button-close:aria-label',
			)}
		/>
	)
}
